import React from 'react';
import AppVariables from '../../common/AppVariables';
import PropTypes from 'prop-types';
import NumberLabel from "../NumberLabel/NumberLabel";

const CurrencyLabel = ({ id , currency ,   value , precision = 0 }) => {
    return <span id={id}>{currency} <NumberLabel value={value} precision={precision}/></span>
};

CurrencyLabel.propTypes = {
    id: PropTypes.any,
    value: PropTypes.any,
    currency: PropTypes.string,
    precision: PropTypes.number
};

CurrencyLabel.defaultProps = {
  currency: AppVariables.CurrencyCode
};


export default CurrencyLabel;


// WEBPACK FOOTER //
// ./src/components/CurrencyLabel/CurrencyLabel.js